export const translations = {
  english: {
    // Header
    appName: "🌾 Kirthi Krishi AI",
    dashboard: "Dashboard",
    cropPrediction: "Crop Prediction",
    diseaseCheck: "Disease Check",
    weather: "Weather",
    myFarm: "My Farm",
    
    // Dashboard
    farmDashboard: "Farm Dashboard",
    todaysInsights: "Today's farming insights and recommendations",
    todaysWeather: "Today's Weather",
    soilMoisture: "Soil Moisture",
    cropHealth: "Crop Health",
    nextHarvest: "Next Harvest",
    days: "Days",
    good: "Good",
    healthy: "Healthy",
    
    // Quick Actions
    quickActions: "Quick Actions",
    checkYieldPrediction: "📊 Check Yield Prediction",
    scanForDiseases: "🔍 Scan for Diseases",
    weatherForecast: "🌧️ 7-Day Weather Forecast",
    
    // Recommendations
    todaysRecommendations: "Today's Recommendations",
    waterTomatoes: "Water your tomatoes today",
    soilMoistureOptimal: "Soil moisture is at 65%, ideal time for watering",
    applyFertilizer: "Apply fertilizer to wheat field",
    growthStageOptimal: "Growth stage optimal for nitrogen application",
    monitorPests: "Monitor for pests",
    weatherFavorsPests: "Weather conditions favor pest activity",
    
    // Crop Prediction
    cropPrediction: "Crop Prediction",
    waterRequirementPrediction: "Water Requirement Prediction",
    yieldPrediction: "Yield Prediction",
    cropType: "Crop Type",
    selectCrop: "Select Crop",
    rice: "Rice",
    wheat: "Wheat",
    tomato: "Tomato",
    potato: "Potato",
    fieldSize: "Field Size",
    growthStage: "Growth Stage",
    initial: "Initial",
    midSeason: "Mid Season",
    lateSeason: "Late Season",
    daysSincePlanting: "Days Since Planting",
    predictWaterNeed: "Predict Water Need",
    predictYield: "Predict Yield",
    
    // Results
    waterRequirement: "Water Requirement",
    daily: "Daily",
    weekly: "Weekly",
    bestWateringTime: "Best watering time: 6:00 AM - 8:00 AM",
    yieldPredictionResult: "Yield Prediction",
    perAcre: "Per acre",
    total: "Total",
    confidence: "Confidence",
    harvestIn: "Harvest in",
    
    // Disease Detection
    diseaseDetection: "Disease Detection",
    uploadLeafImage: "Upload Leaf Image",
    clickToUpload: "Click to upload or drag and drop",
    fileFormat: "PNG, JPG up to 10MB",
    chooseImage: "Choose Image",
    quickTips: "Quick Tips:",
    takeClearPhotos: "• Take clear, well-lit photos",
    focusOnAffected: "• Focus on affected leaf areas",
    avoidBlurry: "• Avoid blurry or dark images",
    analysisResult: "Analysis Result",
    diseaseDetected: "Disease Detected",
    treatmentRecommendations: "Treatment Recommendations",
    preventionTips: "Prevention Tips",
    
    // Weather
    weatherSoilInsights: "Weather & Soil Insights",
    weatherForecast7Day: "7-Day Weather Forecast",
    today: "Today",
    tomorrow: "Tomorrow",
    wednesday: "Wednesday",
    sunny: "Sunny",
    partlyCloudy: "Partly Cloudy",
    lightRain: "Light Rain",
    soilConditions: "Soil Conditions",
    moistureLevel: "Moisture Level",
    phLevel: "pH Level",
    temperature: "Temperature",
    nutrients: "Nutrients",
    medium: "Medium",
    soilOptimal: "✅ Soil conditions are optimal for planting",
    farmingAlerts: "Farming Alerts",
    pestAlert: "Pest Alert",
    irrigationReminder: "Irrigation Reminder",
    harvestReady: "Harvest Ready",
    viewAllAlerts: "View All Alerts",
    
    // Footer
    empoweringFarmers: "Empowering farmers with AI for smarter, sustainable farming.",
    growingTogether: "Growing together towards a greener future.",
    features: "Features",
    cropPredictionFooter: "Crop Prediction",
    diseaseDetectionFooter: "Disease Detection",
    weatherInsights: "Weather Insights",
    soilAnalysis: "Soil Analysis",
    support: "Support",
    helpCenter: "Help Center",
    tutorials: "Tutorials",
    community: "Community",
    contact: "Contact",
    flowering: "Flowering",
    vegetative: "Vegetative",
    fruiting: "Fruiting",
    loading: "Loading...",
    
    // Alert descriptions
    pestAlertDesc: "High aphid activity expected this week",
    irrigationReminderDesc: "Water tomato field tomorrow morning",
    harvestReadyDesc: "Wheat field ready for harvest in 3 days",
    
    // Disease Detection
    tomatoLateBlight: "Tomato Late Blight",
    confidenceLevel: "Confidence",
    applyFungicide: "• Apply copper-based fungicide",
    removeLeaves: "• Remove affected leaves immediately",
    improveAirflow: "• Improve air circulation",
    reduceWatering: "• Reduce watering frequency",
    waterAtSoil: "• Water at soil level, not leaves",
    properSpacing: "• Ensure proper plant spacing",
    monitorHumidity: "• Monitor humidity levels",
    
    // Weather and days
    thursday: "Thursday",
    friday: "Friday", 
    saturday: "Saturday",
    sunday: "Sunday",
    day: "Day",
    rain: "rain",
    cloudy: "Cloudy",
    rainy: "Rainy",
    humidity: "Humidity",
    forCrops: "for crops",
    fieldSizePlaceholder: "5",
    daysPlaceholder: "45",
    acres: "acres",
    
    allRightsReserved: "© 2025 Kirthi Krishi AI. All rights reserved."
  },
  
  hindi: {
    // Header
    appName: "🌾 कृति कृषि AI",
    dashboard: "डैशबोर्ड",
    cropPrediction: "फसल भविष्यवाणी",
    diseaseCheck: "रोग जांच",
    weather: "मौसम",
    myFarm: "मेरा खेत",
    
    // Dashboard
    farmDashboard: "खेत डैशबोर्ड",
    todaysInsights: "आज की खेती की जानकारी और सुझाव",
    todaysWeather: "आज का मौसम",
    soilMoisture: "मिट्टी की नमी",
    cropHealth: "फसल स्वास्थ्य",
    nextHarvest: "अगली फसल",
    days: "दिन",
    good: "अच्छा",
    healthy: "स्वस्थ",
    
    // Quick Actions
    quickActions: "त्वरित कार्य",
    checkYieldPrediction: "📊 उत्पादन भविष्यवाणी देखें",
    scanForDiseases: "🔍 रोगों की जांच करें",
    weatherForecast: "🌧️ 7-दिन मौसम पूर्वानुमान",
    
    // Recommendations
    todaysRecommendations: "आज की सिफारिशें",
    waterTomatoes: "आज अपने टमाटर को पानी दें",
    soilMoistureOptimal: "मिट्टी की नमी 65% है, पानी देने का आदर्श समय",
    applyFertilizer: "गेहूं के खेत में खाद डालें",
    growthStageOptimal: "नाइट्रोजन के लिए वृद्धि चरण आदर्श",
    monitorPests: "कीटों की निगरानी करें",
    weatherFavorsPests: "मौसम की स्थिति कीट गतिविधि के अनुकूल",
    
    // Crop Prediction
    cropPrediction: "फसल भविष्यवाणी",
    waterRequirementPrediction: "पानी की आवश्यकता भविष्यवाणी",
    yieldPrediction: "उत्पादन भविष्यवाणी",
    cropType: "फसल प्रकार",
    selectCrop: "फसल चुनें",
    rice: "चावल",
    wheat: "गेहूं",
    tomato: "टमाटर",
    potato: "आलू",
    fieldSize: "खेत का आकार",
    growthStage: "वृद्धि चरण",
    initial: "प्रारंभिक",
    midSeason: "मध्य सीजन",
    lateSeason: "देर से सीजन",
    daysSincePlanting: "रोपण के बाद दिन",
    predictWaterNeed: "पानी की जरूरत का अनुमान",
    predictYield: "उत्पादन का अनुमान",
    
    // Results
    waterRequirement: "पानी की आवश्यकता",
    daily: "दैनिक",
    weekly: "साप्ताहिक",
    bestWateringTime: "सबसे अच्छा पानी देने का समय: सुबह 6:00 - 8:00",
    yieldPredictionResult: "उत्पादन भविष्यवाणी",
    perAcre: "प्रति एकड़",
    total: "कुल",
    confidence: "विश्वास",
    harvestIn: "फसल में",
    
    // Disease Detection
    diseaseDetection: "रोग का पता लगाना",
    uploadLeafImage: "पत्ती की छवि अपलोड करें",
    clickToUpload: "अपलोड करने के लिए क्लिक करें या खींचें और छोड़ें",
    fileFormat: "PNG, JPG 10MB तक",
    chooseImage: "छवि चुनें",
    quickTips: "त्वरित सुझाव:",
    takeClearPhotos: "• स्पष्ट, अच्छी रोशनी वाली तस्वीरें लें",
    focusOnAffected: "• प्रभावित पत्ती क्षेत्रों पर ध्यान दें",
    avoidBlurry: "• धुंधली या अंधेरी छवियों से बचें",
    analysisResult: "विश्लेषण परिणाम",
    diseaseDetected: "रोग का पता चला",
    treatmentRecommendations: "उपचार सिफारिशें",
    preventionTips: "रोकथाम के सुझाव",
    
    // Weather
    weatherSoilInsights: "मौसम और मिट्टी की जानकारी",
    weatherForecast7Day: "7-दिन मौसम पूर्वानुमान",
    today: "आज",
    tomorrow: "कल",
    wednesday: "बुधवार",
    sunny: "धूप",
    partlyCloudy: "आंशिक बादल",
    lightRain: "हल्की बारिश",
    soilConditions: "मिट्टी की स्थिति",
    moistureLevel: "नमी का स्तर",
    phLevel: "pH स्तर",
    temperature: "तापमान",
    nutrients: "पोषक तत्व",
    medium: "मध्यम",
    soilOptimal: "✅ रोपण के लिए मिट्टी की स्थिति आदर्श है",
    farmingAlerts: "खेती अलर्ट",
    pestAlert: "कीट अलर्ट",
    irrigationReminder: "सिंचाई अनुस्मारक",
    harvestReady: "फसल तैयार",
    viewAllAlerts: "सभी अलर्ट देखें",
    
    // Footer
    empoweringFarmers: "स्मार्ट, टिकाऊ खेती के लिए AI के साथ किसानों को सशक्त बनाना।",
    growingTogether: "हरित भविष्य की दिशा में एक साथ बढ़ना।",
    features: "विशेषताएं",
    cropPredictionFooter: "फसल भविष्यवाणी",
    diseaseDetectionFooter: "रोग का पता लगाना",
    weatherInsights: "मौसम की जानकारी",
    soilAnalysis: "मिट्टी विश्लेषण",
    support: "सहायता",
    helpCenter: "सहायता केंद्र",
    tutorials: "ट्यूटोरियल",
    community: "समुदाय",
    contact: "संपर्क",
    flowering: "फूल आना",
    vegetative: "वनस्पति",
    fruiting: "फल लगना",
    loading: "लोड हो रहा है...",
    
    // Alert descriptions
    pestAlertDesc: "इस सप्ताह उच्च एफिड गतिविधि की उम्मीद",
    irrigationReminderDesc: "कल सुबह टमाटर के खेत में पानी दें",
    harvestReadyDesc: "3 दिन में गेहूं का खेत कटाई के लिए तैयार",
    
    // Disease Detection
    tomatoLateBlight: "टमाटर लेट ब्लाइट",
    confidenceLevel: "विश्वास",
    applyFungicide: "• तांबा आधारित फंगीसाइड लगाएं",
    removeLeaves: "• प्रभावित पत्तियों को तुरंत हटा दें",
    improveAirflow: "• हवा के प्रवाह में सुधार करें",
    reduceWatering: "• पानी देने की आवृत्ति कम करें",
    waterAtSoil: "• मिट्टी के स्तर पर पानी दें, पत्तियों पर नहीं",
    properSpacing: "• पौधों के बीच उचित दूरी सुनिश्चित करें",
    monitorHumidity: "• नमी के स्तर की निगरानी करें",
    
    // Weather and days
    thursday: "गुरुवार",
    friday: "शुक्रवार",
    saturday: "शनिवार",
    sunday: "रविवार",
    day: "दिन",
    rain: "बारिश",
    cloudy: "बादल",
    rainy: "बरसाती",
    humidity: "नमी",
    forCrops: "फसलों के लिए",
    fieldSizePlaceholder: "5",
    daysPlaceholder: "45",
    acres: "एकड़",
    
    allRightsReserved: "© 2025 कृति कृषि AI। सभी अधिकार सुरक्षित।"
  },
  
  tamil: {
    // Header
    appName: "🌾 கிர்த்தி கிருஷி AI",
    dashboard: "டாஷ்போர்டு",
    cropPrediction: "பயிர் கணிப்பு",
    diseaseCheck: "நோய் பரிசோதனை",
    weather: "வானிலை",
    myFarm: "என் பண்ணை",
    
    // Dashboard
    farmDashboard: "பண்ணை டாஷ்போர்டு",
    todaysInsights: "இன்றைய விவசாய நுண்ணறிவுகள் மற்றும் பரிந்துரைகள்",
    todaysWeather: "இன்றைய வானிலை",
    soilMoisture: "மண் ஈரப்பதம்",
    cropHealth: "பயிர் ஆரோக்கியம்",
    nextHarvest: "அடுத்த அறுவடை",
    days: "நாட்கள்",
    good: "நல்லது",
    healthy: "ஆரோக்கியமான",
    
    // Quick Actions
    quickActions: "விரைவு செயல்கள்",
    checkYieldPrediction: "📊 விளைச்சல் கணிப்பைப் பார்க்கவும்",
    scanForDiseases: "🔍 நோய்களுக்கு ஸ்கேன் செய்யவும்",
    weatherForecast: "🌧️ 7-நாள் வானிலை முன்னறிவிப்பு",
    
    // Recommendations
    todaysRecommendations: "இன்றைய பரிந்துரைகள்",
    waterTomatoes: "இன்று உங்கள் தக்காளிக்கு தண்ணீர் கொடுங்கள்",
    soilMoistureOptimal: "மண் ஈரப்பதம் 65% உள்ளது, தண்ணீர் கொடுக்க சிறந்த நேரம்",
    applyFertilizer: "கோதுமை வயலில் உரம் போடுங்கள்",
    growthStageOptimal: "நைட்ரஜன் பயன்பாட்டிற்கு வளர்ச்சி நிலை சிறந்தது",
    monitorPests: "பூச்சிகளை கண்காணிக்கவும்",
    weatherFavorsPests: "வானிலை நிலைமைகள் பூச்சி செயல்பாட்டிற்கு சாதகமாக உள்ளன",
    
    // Crop Prediction
    cropPrediction: "பயிர் கணிப்பு",
    waterRequirementPrediction: "நீர் தேவை கணிப்பு",
    yieldPrediction: "விளைச்சல் கணிப்பு",
    cropType: "பயிர் வகை",
    selectCrop: "பயிரைத் தேர்ந்தெடுக்கவும்",
    rice: "அரிசி",
    wheat: "கோதுமை",
    tomato: "தக்காளி",
    potato: "உருளைக்கிழங்கு",
    fieldSize: "வயல் அளவு",
    growthStage: "வளர்ச்சி நிலை",
    initial: "ஆரம்ப",
    midSeason: "நடு பருவம்",
    lateSeason: "தாமத பருவம்",
    daysSincePlanting: "நடவு செய்த நாட்கள்",
    predictWaterNeed: "நீர் தேவையை கணிக்கவும்",
    predictYield: "விளைச்சலை கணிக்கவும்",
    
    // Results
    waterRequirement: "நீர் தேவை",
    daily: "தினசரி",
    weekly: "வாராந்திர",
    bestWateringTime: "சிறந்த நீர்ப்பாசன நேரம்: காலை 6:00 - 8:00",
    yieldPredictionResult: "விளைச்சல் கணிப்பு",
    perAcre: "ஒரு ஏக்கருக்கு",
    total: "மொத்தம்",
    confidence: "நம்பிக்கை",
    harvestIn: "அறுவடை",
    
    // Disease Detection
    diseaseDetection: "நோய் கண்டறிதல்",
    uploadLeafImage: "இலை படத்தை பதிவேற்றவும்",
    clickToUpload: "பதிவேற்ற கிளிக் செய்யவும் அல்லது இழுத்து விடவும்",
    fileFormat: "PNG, JPG 10MB வரை",
    chooseImage: "படத்தைத் தேர்ந்தெடுக்கவும்",
    quickTips: "விரைவு குறிப்புகள்:",
    takeClearPhotos: "• தெளிவான, நல்ல வெளிச்சமுள்ள புகைப்படங்களை எடுக்கவும்",
    focusOnAffected: "• பாதிக்கப்பட்ட இலை பகுதிகளில் கவனம் செலுத்தவும்",
    avoidBlurry: "• மங்கலான அல்லது இருண்ட படங்களைத் தவிர்க்கவும்",
    analysisResult: "பகுப்பாய்வு முடிவு",
    diseaseDetected: "நோய் கண்டறியப்பட்டது",
    treatmentRecommendations: "சிகிச்சை பரிந்துரைகள்",
    preventionTips: "தடுப்பு குறிப்புகள்",
    
    // Weather
    weatherSoilInsights: "வானிலை மற்றும் மண் நுண்ணறிவுகள்",
    weatherForecast7Day: "7-நாள் வானிலை முன்னறிவிப்பு",
    today: "இன்று",
    tomorrow: "நாளை",
    wednesday: "புதன்கிழமை",
    sunny: "வெயில்",
    partlyCloudy: "பகுதி மேகமூட்டம்",
    lightRain: "லேசான மழை",
    soilConditions: "மண் நிலைமைகள்",
    moistureLevel: "ஈரப்பத நிலை",
    phLevel: "pH நிலை",
    temperature: "வெப்பநிலை",
    nutrients: "ஊட்டச்சத்துக்கள்",
    medium: "நடுத்தர",
    soilOptimal: "✅ நடவுக்கு மண் நிலைமைகள் சிறந்தவை",
    farmingAlerts: "விவசாய எச்சரிக்கைகள்",
    pestAlert: "பூச்சி எச்சரிக்கை",
    irrigationReminder: "நீர்ப்பாசன நினைவூட்டல்",
    harvestReady: "அறுவடை தயார்",
    viewAllAlerts: "அனைத்து எச்சரிக்கைகளையும் பார்க்கவும்",
    
    // Footer
    empoweringFarmers: "ஸ்மார்ட், நிலையான விவசாயத்திற்காக AI உடன் விவசாயிகளை வலுப்படுத்துதல்।",
    growingTogether: "பசுமையான எதிர்காலத்தை நோக்கி ஒன்றாக வளர்ந்து வருகிறோம்।",
    features: "அம்சங்கள்",
    cropPredictionFooter: "பயிர் கணிப்பு",
    diseaseDetectionFooter: "நோய் கண்டறிதல்",
    weatherInsights: "வானிலை நுண்ணறிவுகள்",
    soilAnalysis: "மண் பகுப்பாய்வு",
    support: "ஆதரவு",
    helpCenter: "உதவி மையம்",
    tutorials: "பயிற்சிகள்",
    community: "சமூகம்",
    contact: "தொடர்பு",
    flowering: "பூக்கும் காலம்",
    vegetative: "தாவர வளர்ச்சி",
    fruiting: "கனி காலம்",
    loading: "ஏற்றுகிறது...",
    
    // Alert descriptions
    pestAlertDesc: "இந்த வாரம் அஃபிட் செயல்பாடு அதிகம் எதிர்பார்க்கப்படுகிறது",
    irrigationReminderDesc: "நாளை காலை தக்காளி வயலில் நீர் கொடுங்கள்",
    harvestReadyDesc: "3 நாட்களில் கோதுமை வயல் அறுவடைக்கு தயார்",
    
    // Disease Detection
    tomatoLateBlight: "தக்காளி லேட் ப்ளைட்",
    confidenceLevel: "நம்பிக்கை",
    applyFungicide: "• காப்பர் அடிப்படை கவக விரோதி மருந்தை பயன்படுத்தவும்",
    removeLeaves: "• பாதிக்கப்பட்ட இலைகளை உடனே அகற்றவும்",
    improveAirflow: "• காற்று சுழற்சியை மேம்படுத்தவும்",
    reduceWatering: "• நீர் கொடுக்கும் அழிவை குறைக்கவும்",
    waterAtSoil: "• இலைகளில் அல்லாமல் மண் மட்டத்தில் நீர் கொடுங்கள்",
    properSpacing: "• செடிகளுக்கு இடையே சரியான இடைவெளியை உறுதி செய்யவும்",
    monitorHumidity: "• ஈர்ப்பத நிலைகளை கண்காணிக்கவும்",
    
    // Weather and days
    thursday: "வியாழக்கிழமை",
    friday: "வெள்ளிக்கிழமை",
    saturday: "சனிக்கிழமை",
    sunday: "ஞாயிற்றுக்கிழமை",
    day: "நாள்",
    rain: "மழை",
    cloudy: "மேகமூட்டம்",
    rainy: "மழையான",
    humidity: "ஈர்ப்பதம்",
    forCrops: "பயிர்களுக்கு",
    fieldSizePlaceholder: "5",
    daysPlaceholder: "45",
    acres: "ஏக்கர்",
    
    allRightsReserved: "© 2025 கிர்த்தி கிருஷி AI. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை."
  },
  
  telugu: {
    // Header
    appName: "🌾 కీర్తి కృషి AI",
    dashboard: "డాష్‌బోర్డ్",
    cropPrediction: "పంట పూర్వానుమానం",
    diseaseCheck: "రోగ పరీక్ష",
    weather: "వాతావరణం",
    myFarm: "నా వేళాం",
    
    // Dashboard
    farmDashboard: "వేళాం డాష్‌బోర్డ్",
    todaysInsights: "ఈరోజు వేళాం సలహాలు మరియు సూచనలు",
    todaysWeather: "ఈరోజు వాతావరణం",
    soilMoisture: "మిట్టి నమి",
    cropHealth: "పంట ఆరోగ్యం",
    nextHarvest: "తదుపరి కొయ్య",
    days: "రోజులు",
    good: "మంచి",
    healthy: "ఆరోగ్యకరమైన",
    
    // Crop Prediction
    waterRequirementPrediction: "నీరు అవసరం పూర్వానుమానం",
    yieldPrediction: "ఉత్పాదన పూర్వానుమానం",
    cropType: "పంట రకం",
    selectCrop: "పంటను ఎంచుకోండి",
    rice: "వాదాము",
    wheat: "గోధుమలు",
    tomato: "టమాటో",
    potato: "ఆలుగెడ్డ",
    fieldSize: "వేళాం పరిమాణం",
    growthStage: "వృద్ధి దశ",
    initial: "ప్రారంభిక",
    midSeason: "మధ్య కాలం",
    lateSeason: "కొనసాగిన కాలం",
    daysSincePlanting: "విత్తనాలింద రోజులు",
    predictWaterNeed: "నీరు అవసరం అనుమానించు",
    predictYield: "ఉత్పాదన అనుమానించు",
    
    // Results
    waterRequirement: "నీరు అవసరం",
    daily: "రోజువారీ",
    weekly: "వారంవారీ",
    bestWateringTime: "ఉత్తమ నీరు వేళ: ఉదయం 6:00 - 8:00",
    yieldPredictionResult: "ఉత్పాదన పూర్వానుమానం",
    perAcre: "ఏకరానికి",
    total: "మొత్తం",
    confidence: "విశ్వాసం",
    harvestIn: "కొయ్యలో",
    
    // Weather and days
    thursday: "గురువారం",
    friday: "శుక్రవారం",
    saturday: "శనివారం",
    sunday: "ఆదివారం",
    day: "రోజు",
    rain: "వర్షం",
    cloudy: "మేఘాలు",
    rainy: "వర్షాకాలం",
    humidity: "తేమ",
    forCrops: "పంటల కోసం",
    fieldSizePlaceholder: "5",
    daysPlaceholder: "45",
    acres: "ఏకరాలు",
    
    // Additional terms
    flowering: "పూలులు వికసించడం",
    vegetative: "వనస్పతి వృద్ధి",
    fruiting: "ఫలాలు వికసించడం",
    loading: "లోడ్ అవుతోంది...",
    
    allRightsReserved: "© 2025 కీర్తి కృషి AI. అన్ని హక్కులు రక్షితాలు."
  },
  
  gujarati: {
    // Header
    appName: "🌾 કીર્તિ કૃષિ AI",
    dashboard: "ડેશબોર્ડ",
    cropPrediction: "ફસલ ભવિષ્યવાણી",
    diseaseCheck: "રોગ જાંચ",
    weather: "મોસમ",
    myFarm: "મારું શેત",
    
    // Dashboard
    farmDashboard: "શેત ડેશબોર્ડ",
    todaysInsights: "આજની શેતી માહિતી અને સુઝાવો",
    todaysWeather: "આજનું મોસમ",
    soilMoisture: "માટીનું ઓશ",
    cropHealth: "ફસલ આરોગ્ય",
    nextHarvest: "અગલી વાવણી",
    days: "દિવસ",
    good: "સારું",
    healthy: "નિરોગી",
    
    // Crop Prediction
    waterRequirementPrediction: "પાણીની જરૂરિયાત ભવિષ્યવાણી",
    yieldPrediction: "ઉત્પાદન ભવિષ્યવાણી",
    cropType: "ફસલનો પ્રકાર",
    selectCrop: "ફસલ પસંદ કરો",
    rice: "ભાત",
    wheat: "ગહું",
    tomato: "ટમેટાં",
    potato: "બટાકા",
    fieldSize: "શેતનો આકાર",
    growthStage: "વૃદ્ધિનો ટપ્પો",
    initial: "પ્રારંભિક",
    midSeason: "મધ્ય સીઝન",
    lateSeason: "ઉત્તર સીઝન",
    daysSincePlanting: "વાવેતર દિવસો",
    predictWaterNeed: "પાણીની જરૂરિયાતનો અંદાજ",
    predictYield: "ઉત્પાદનનો અંદાજ",
    
    allRightsReserved: "© 2025 કીર્તિ કૃષિ AI. બધા હક્કો રક્ષિત."
  },
  
  kannada: {
    // Header
    appName: "🌾 ಕೀರ್ತಿ ಕೃಷಿ AI",
    dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    cropPrediction: "ಬೆಳೆ ಭವಿಷ್ಯವಾಣಿ",
    diseaseCheck: "ರೋಗ ಪರಿಶೀಲನೆ",
    weather: "ಹವಾಮಾನ",
    myFarm: "ನನ್ನ ಹೆಂಗಸು",
    
    // Dashboard
    farmDashboard: "ಹೆಂಗಸು ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    todaysInsights: "ಇಂದಿನ ಹೆಂಗಸು ಅಂತರ್ದೃಷ್ಟಿಗಳು ಮತ್ತು ಸೂಚನೆಗಳು",
    todaysWeather: "ಇಂದಿನ ಹವಾಮಾನ",
    soilMoisture: "ಮಣ್ಣಿನ ನಮಿ",
    cropHealth: "ಬೆಳೆ ಆರೋಗ್ಯ",
    nextHarvest: "ಮುಂದಿನ ಸೆಕತ",
    days: "ದಿನಗಳು",
    good: "ಚಂದ",
    healthy: "ಆರೋಗ್ಯವಾಗಿ",
    
    allRightsReserved: "© 2025 ಕೀರ್ತಿ ಕೃಷಿ AI. ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಸಂರಕ್ಷಿತ."
  }
};

export const useTranslation = (language) => {
  return (key) => translations[language]?.[key] || translations.english[key] || key;
};